import { css } from 'aphrodite';
import { Button } from '../../../../web/components-v2/Button';
import type { SessionBatch } from './labBatch';
import { styles } from './styles';

/** The calls saved this sitting, with one download for all of them. */
export const SessionBatchPanel = ({ batch }: { batch: SessionBatch }) => {
	const { entries, notDownloaded } = batch;
	return (
		<section className={css(styles.tipCard, styles.batchCard)}>
			<h3 className={css(styles.tipTitle)}>Calls this sitting ({entries.length})</h3>
			{entries.length === 0 ? (
				<p className={css(styles.help)}>
					Each call you save lands here. Do as many as you like, then download them all at once and send the file to
					Jes.
				</p>
			) : (
				<>
					<ul className={css(styles.batchList)}>
						{entries.map(e => (
							<li key={e.id} className={css(styles.batchItem)}>
								<span>
									{e.label}
									<span className={css(styles.pickItemMeta)}>
										{e.kind}
										{e.downloaded ? ', downloaded' : ''}
									</span>
								</span>
								{!e.downloaded ? (
									<Button variant='link' size='sm' onClick={() => batch.remove(e.id)}>
										Remove
									</Button>
								) : null}
							</li>
						))}
					</ul>
					<div className={css(styles.actions)}>
						<Button variant='primary' size='sm' onClick={batch.downloadAll}>
							Download all ({entries.length})
						</Button>
						{notDownloaded === 0 ? (
							<Button variant='secondary' size='sm' onClick={batch.clear}>
								Start a new list
							</Button>
						) : null}
					</div>
					<p className={css(styles.help)}>
						{notDownloaded > 0
							? `${notDownloaded} not downloaded yet. They stay in this tab until you download them, even if you refresh.`
							: 'All downloaded. Send the file to Jes.'}
					</p>
				</>
			)}
		</section>
	);
};
